/* eslint-disable lodash/prefer-lodash-method */
import { isString } from 'lodash';

function createUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16),
    );
}

function sanitizeDoubleSlashOnUrl(url) {
    if (!isString(url)) return '';
    return url.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
}

function getLocalParam(url, locale) {
    const isLocalPresentInUri = url.searchParams.has('locale')
    const hasOtherParamsExceptLocal = !!url.search && !isLocalPresentInUri
    const prefix = hasOtherParamsExceptLocal ? '&' : '?'
    return locale && !isLocalPresentInUri ? `${prefix}locale=${locale}` : ''
}

export {
    createUUID,
    sanitizeDoubleSlashOnUrl,
    getLocalParam
};
